import { Component, Input, OnInit } from '@angular/core';
import { ProductServicePricingPlan } from '../../../models';
import { PricingPlanService } from 'services';

@Component({
	selector: 'app-product-service-pricing-plan',
	template: require('./product-service-pricing-plan.component.html'),
	styles: [require('./product-service-pricing-plan.component.scss')],
	host: { class: 'flex flex-col flex-1 overflow-hidden mt-10 lg:mt-0' },
})
export class ProductServicePricingPlanComponent implements OnInit {
	@Input() clientId: string;

	productServicePricingPlans: ProductServicePricingPlan[];

	constructor(private pricingPlanService: PricingPlanService) {}

	ngOnInit() {
		this.pricingPlanService.getProductServicePricingPlans(this.clientId).subscribe(r => {
			this.productServicePricingPlans = r;
		});
	}
}
